// extracted by mini-css-extract-plugin
export default {"root":"s3BDW5","header":"A93o0c","main":"rRrBPz","sidebar":"gtvZ9_","flip":"xzgsS8","mobile":"tjrhkf","title":"k7eLrE","subtitle":"rjGMJ1"};